import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) { }

    transform(value: number, decimals?: number) {
        const _sizebreaks = [0, 1000, 1000000, 1000000000, 1000000000000];
        const _sizeextents = ['B', 'kB', 'MB', 'GB', 'TB'];

        if (!value) { return ''; }

        for (let i = _sizebreaks.length - 1; i >= 0; --i) {
            if (_sizebreaks[i] <= value) {
                const major = (_sizebreaks[i] > 0 ? (value * 1.0 / _sizebreaks[i]) : value);
                const minor = (decimals != null ? decimals : 2);

                return `${this.decimalPipe.transform(major, `1.${minor}-${minor}`)} ${_sizeextents[i]}`;
            }
        }
    }
}
